import routerOptions0 from "/builds/application/sim-portal/monorepo/node_modules/.pnpm/nuxt@3.21.9_@parcel+watcher@2.5.6_@types+node@22.10.7_@vue+compiler-sfc@3.5.40_cac@6.7._c7871f915bcfe8c7b3e96b0e7d14a624/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}